var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"hero-text",class:[
    {
      'hero-text--visible': _vm.visible,
      'hero-text--invert': _vm.invert,
      'hero-text--alone': _vm.alone,
      'hero-text--scale': _vm.scale
    },
    ("hero-text--" + _vm.align),
    ("hero-text--" + _vm.name)
  ],style:({ fontSize: (_vm.fontSize + "px") })},[_c('span',{staticClass:"hero-text__content",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0189eecf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroAnimation/HeroText.vue
// module id = null
// module chunks = 